import { Image } from '@components/products/products'
import { API_URL } from '@constants'
import axiosReadInstance from '../../request/axiosReadInstance'
import { useEffect, useState } from 'react'
import 'moment/locale/fr'
import { ArticleC } from '@components/article/article'
import { replaceImageExtension } from '@utils'

interface IUseCase {
    attributes: {
        title: string
        description: string
        image: Image
        client: string
        use_case_detail: {
            data: {
                id: any
            }
        }
    }
    id: any
}

interface IREalisation {
    attributes: {
        title: string
        description: string
        use_cases?: {
            data: Array<IUseCase>
        }
    }
    isFilter: Boolean
}

export const RealisationCases: React.FC = () => {
    const start: number = 0
    const initialLimit = 6
    const [limit, setLimit] = useState<number>(initialLimit)
    const pageSize: number = 6
    const [realisationCases, setRealisationCases] = useState<Array<IUseCase>>()
    const [realisationCasesFiltered, setRealisationCasesFiltered] =
        useState<Array<IUseCase>>()
    const [realisations, setRealisations] = useState<Array<IREalisation>>()
    const [fade, setFade] = useState(true)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadMore, setLoadMore] = useState<boolean>(true)
    const [noMore, setNoMore] = useState<boolean>(false)
    const hash = window.location.hash.substring(1)
    function handleClick(filter: IREalisation) {
        setFade(true)
        if (filter.isFilter) {
            filter.isFilter = false
            setRealisationCasesFiltered(realisationCases)
        } else {
            realisations?.forEach((element) => {
                if (element != filter && element.isFilter) {
                    element.isFilter = false
                }
            })
            filter.isFilter = true
            setRealisationCasesFiltered(filter.attributes.use_cases?.data)
        }
        setFade(false)
    }
    async function fetchData() {
        setFade(true)
        await axiosReadInstance
            .get(
                `${API_URL}/api/use-cases?pagination[start]=` +
                    start +
                    `&pagination[limit]=` +
                    limit +
                    `&populate=*`
            )
            .then((response) => {
                if (limit >= response.data.meta.pagination.total) {
                    setNoMore(true)
                } else {
                    setNoMore(false)
                }
                setRealisationCases(response.data.data)
                setRealisationCasesFiltered(response.data.data)
            })
        await axiosReadInstance
            .get(`${API_URL}/api/use-case-categories?populate=deep`)
            .then((response) => {
                setRealisations(response.data.data)
                realisations?.forEach((element) => {
                    element.isFilter = false
                })
            })
        setFade(false)
    }

    useEffect(() => {
        if (hash.length > 0) {
            const selectedrealisation = realisations?.find(
                (realisation) => stringToSlug(realisation.attributes.title) === hash
            )
            if (selectedrealisation) {
                handleClick(selectedrealisation)
            }
        }
    }, [hash, realisations])
    

    useEffect(() => {
        setLoadMore(true)
        fetchData().then(() => {
            setLoadMore(false)
        })
    }, [limit])

    function stringToSlug(str: string) {
        return str
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
    }

    return (
        <section className="py-6 px-6 sm:px-4">
            <div className="max-w-screen-xl mx-auto">
                <div className="flex flex-wrap gap-2 md:gap-1 md:flex-row justify-evenly">
                    {realisations?.map((category, index) => {
                        return (
                            <button
                                key={index}
                                onClick={() => handleClick(category)}
                                className={`rounded-full py-2 px-4 text-sm " + ${
                                    category.isFilter
                                        ? 'realisation-active'
                                        : 'realisation-inactive'
                                } `}
                            >
                                {category.attributes.title}
                            </button>
                        )
                    })}
                </div>
                {loading && (
                    <div className="flex justify-center">
                        <svg
                            aria-hidden="true"
                            className="inline w-12 h-12 mr-2 animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="#e5e7eb"
                            />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="#22c55e"
                            />
                        </svg>
                        <span className="sr-only">Loading...</span>
                    </div>
                )}

                {loading == false && (
                    <div
                        id="realisations"
                        className={`mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 auto-rows-auto  gap-x-6 gap-y-24 ${
                            fade ? 'animate-pulse' : ''
                        } `}
                    >
                        {realisationCasesFiltered?.map((realisationCase, index) => {
                            const url = `/realisation-detail/${realisationCase.id}/${realisationCase.attributes.use_case_detail.data.id}`

                            return (
                                <ArticleC
                                    HnTitle="h2"
                                    url={url}
                                    title={realisationCase.attributes.title}
                                    subtitle={realisationCase.attributes.client}
                                    description={
                                        realisationCase.attributes.description
                                    }
                                    srcImg={
                                        replaceImageExtension(realisationCase.attributes.image.data
                                            .attributes.url)
                                    }
                                    altImg=""
                                    knowMoreText="En savoir plus"
                                    key={index}
                                />
                            )
                        })}
                    </div>
                )}

                {loading == false && loadMore && (
                    <div className="flex justify-center mt-10">
                        <svg
                            aria-hidden="true"
                            className="inline w-12 h-12 mr-2 animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="#e5e7eb"
                            />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="#22c55e"
                            />
                        </svg>
                        <span className="sr-only">Loading...</span>
                    </div>
                )}
                <div className="flex justify-center">
                    {loading == false && loadMore == false && noMore == false && (
                        <button
                            className="button-secondary px-10 py-1 mt-10"
                            onClick={async () => {
                                await setLimit(limit + pageSize)
                            }}
                        >
                            Voir plus
                        </button>
                    )}
                </div>
            </div>
        </section>
    )
}
